import React from "react";
import getPkmn from "../../../Assets/Data/Pokedex";
import AbilityName from "../../../Util/AbilityName";
import ReactDOMServer from 'react-dom/server';

const AbilityNames = props => {
    // eslint-disable-next-line
    const pkmnData = getPkmn(props.species, props.altForm);
    const abilityList = [];
    const abilities = pkmnData.Abilities.map(num => ReactDOMServer.renderToStaticMarkup(<AbilityName id={num} />));
    
    if(props.ability < 3) {
        abilityList.push(abilities[props.ability])
    } else if(props.ability === 3) {
        if(pkmnData.Abilities[0] === pkmnData.Abilities[1]) {
            abilityList.push(abilities[0])
        } else {
            abilityList.push(abilities[0])
            abilityList.push(abilities[1])
        }
    } else {
        if(pkmnData.Abilities[0] === pkmnData.Abilities[1] && pkmnData.Abilities[1] === pkmnData.Abilities[2]) {
            abilityList.push(abilities[0])
        } else if(pkmnData.Abilities[0] === pkmnData.Abilities[1]) {
            abilityList.push(abilities[0])
            abilityList.push(abilities[2]+ " (H)")
        } else {
            abilityList.push(abilities[0])
            abilityList.push(abilities[1])
            abilityList.push(abilities[2] + " (H)")
        }
    }

    return (<ul>
        {abilityList.map((v, idx) => {
            return <li key={idx}>{v}</li>
        })}       
    </ul>);
}

export default AbilityNames;